<template>
    <app-main>
        <app-content>
        
            <!-- Start Title -->
            <app-title
                title="Dashboard"
            />
            <!-- End Title -->

        </app-content>
    </app-main>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    export default {
        name: 'home',

        data: () => ({
            
        }),
        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/Home.vue